import React from 'react';
import HotspotEditor from '../Components/Hotspot/HotspotEditor';
import { EnsureKontentAsParent } from '../CustomElement/EnsureKontentAsParent';

const HotSpotCustomElement: React.FC = () => {
  return (
    <EnsureKontentAsParent>
      <HotspotEditor
        imageUrl=""
        onHotspotsChange={hotspots =>
          console.log('Updated hotspots:', hotspots)
        }
      />
    </EnsureKontentAsParent>
  );
};

export default HotSpotCustomElement;
